/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemTriggers = 'GoBackToPrevious' | 'OfferingCompleted' | 'RatingCompleted' | 'DecisionCompleted' | 'NoDecision' | 'SkipSimapPublication' | 'CommunicationAwardCompleted';

export const ItemTriggers = {
    GoBackToPrevious: 'GoBackToPrevious' as ItemTriggers,
    OfferingCompleted: 'OfferingCompleted' as ItemTriggers,
    RatingCompleted: 'RatingCompleted' as ItemTriggers,
    DecisionCompleted: 'DecisionCompleted' as ItemTriggers,
    NoDecision: 'NoDecision' as ItemTriggers,
    SkipSimapPublication: 'SkipSimapPublication' as ItemTriggers,
    CommunicationAwardCompleted: 'CommunicationAwardCompleted' as ItemTriggers
};

